import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['sequentialOnly', 'modeInput']

  connect() {
    this.update()
  }

  update() {
    const isSequential = this.currentMode() === 'sequential'
    this.sequentialOnlyTargets.forEach((element) => {
      element.classList.toggle('hidden', !isSequential)
    })
  }

  sequentialOnlyTargetConnected(element) {
    element.classList.toggle('hidden', this.currentMode() !== 'sequential')
  }

  currentMode() {
    const checked = this.modeInputTargets.find((input) => input.checked)
    return checked ? checked.value : 'sequential'
  }
}
